module.exports = __webpack_public_path__ + "img/save.fb8bdb72.svg";